import React from "react";
import styled from "styled-components";

const OptionsSelectorGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 10px;
  row-gap: 10px;
  margin-top: 15px;
  margin-bottom: 10px;

  &.disabled {
    .OptionsSelectorGridButton {
      background: #e9e9e9;
      border-color: #b0b0b0;
      pointer-events: none;

      .label {
        color: #656565;
      }

      .badge {
        background: #656565;
      }

      .check {
        svg {
          circle {
            fill: #656565;
          }
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const OptionsSelectorGridButton = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
  border: solid 1px #b0b0b0;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 9px 5px;
  transition: all ease-in-out 0.2s;
  cursor: pointer;

  &.option-selector-current {
    border-color: #eb0067;
    border-width: 2px;
    background: #fff3f3;
  }

  .check {
    position: absolute;
    top: -10px;
    right: -10px;
  }

  .badge {
    color: white;
    font-size: 10px;
    display: flex;
    align-items: center;
    column-gap: 5px;
    font-weight: 700;
    width: auto;
    padding: 3px 5px;
    border-radius: 13px;
    background: #eb0067;
    position: absolute;
    top: -13px;
  }

  .label {
    color: #373737;
    cursor: pointer;
  }
`;

const OptionSelectorGridItem = ({ item, onChange, selected }) => {
  return (
    <>
      <OptionsSelectorGridButton
        onClick={() => {
          onChange(item);
        }}
        className={
          selected?.id === item.id
            ? "option-selector-current OptionsSelectorGridButton"
            : "OptionsSelectorGridButton"
        }
      >
        {item.recommended && (
          <span class="badge">
            <svg
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 0L6.29313 3.22016L9.75528 3.45492L7.09232 5.67984L7.93893 9.04508L5 7.2L2.06107 9.04508L2.90768 5.67984L0.244718 3.45492L3.70687 3.22016L5 0Z"
                fill="white"
              />
            </svg>
            POPULAR
          </span>
        )}
        {selected?.id === item.id && (
          <span className="check">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="9" fill="#EB0067" />
              <path
                d="M5.14258 9.32145L7.71401 11.8929L13.1783 6.42859"
                stroke="white"
                strokeWidth="2"
              />
            </svg>
          </span>
        )}
        <label className="label">
          {item.label}
          <input
            type="radio"
            value={item.id}
            checked={selected?.id === item.id}
          />
        </label>
      </OptionsSelectorGridButton>
    </>
  );
};

export const OptionsSelector = ({ options, selected, onChange }) => {
  return (
    <>
      <OptionsSelectorGrid>
        {Array.isArray(options) &&
          options.length > 0 &&
          options.map((item) => (
            <OptionSelectorGridItem
              key={item.id}
              onChange={onChange}
              item={item}
              selected={selected}
            />
          ))}
      </OptionsSelectorGrid>
    </>
  );
};
